import Cookies from 'js-cookie';

export default class Popup {
    constructor() {
        this.popup = document.querySelector('.popup');
        if (!!this.popup) this.showPopup();
    }

    checkDateRange() {
        const startDate = new Date(this.popup.dataset.start);
        const endDate = new Date(this.popup.dataset.end);
        const today = new Date();

        if (!startDate || !endDate) return true;
        return startDate <= today && today <= endDate;
    }

    checkCookie() {
        const tagCookie = Cookies.get('popup');
        if (!!tagCookie && tagCookie === this.popup.dataset.tag) return false;

        const {days, mode} = this.popup.dataset;

        switch (mode) {
            case 'days':
                Cookies.set('popup', this.popup.dataset.tag, {expires: parseInt(days, 10)});
                return true;
            case 'session':
                Cookies.set('popup', this.popup.dataset.tag);
                return true;
            default:
                return false;
        }
    }

    showPopup() {
        if (this.checkDateRange() && this.checkCookie()) {
            this.popup.showPopover();
        }
    }
}